import { WIDGET_TYPE } from "../../../types/widgets";
import BarChartWidgetSample from "../components/sampleWidgets/barChartWidget";
import DonutWidgetSample from "../components/sampleWidgets/donutWidget";
import ListWidgetSample from "../components/sampleWidgets/listWidget";
import MenuEngineeringWidgetSample from "../components/sampleWidgets/menuEngineeringWidget";
import TrendsWidgetSample from "../components/sampleWidgets/trendsWidget";

const sampleWidgetsList = [
  {
    type: WIDGET_TYPE.LIST_MD,
    component: ListWidgetSample,
  },
  {
    type: WIDGET_TYPE.DONUT_DUAL_LG,
    component: DonutWidgetSample,
  },
  {
    type: WIDGET_TYPE.DONUT_MD,
    component: DonutWidgetSample,
  },
  {
    type: WIDGET_TYPE.BAR_LINE_COMBO_LG,
    component: BarChartWidgetSample,
  },
  {
    type: WIDGET_TYPE.BAR_MD,
    component: BarChartWidgetSample,
  },
  {
    type: WIDGET_TYPE.MAGIC_QUADRANT_LG,
    component: MenuEngineeringWidgetSample,
  },
  {
    type: WIDGET_TYPE.STACKED_BAR_CHART,
    component: BarChartWidgetSample,
  },
  {
    type: WIDGET_TYPE.TRENDS_LG,
    component: TrendsWidgetSample,
  },
];

export default sampleWidgetsList;
